import Vue from 'vue'
// var sysInfo = null
// {{{ loadSysInfo
// const DEMO_DATA = {
// 	name: '天财商龙供应链供货商EDI',
// 	logo: './static/img/logo.png',
// 	enable: true,
// 	showDomain: false
// }
const DEMO_DATA = null
// }}}

export default {
	// {{{ getSysInfo
	getSysInfo () {
		if (DEMO_DATA) {
			return Promise.resolve(DEMO_DATA)
		} else {
			return Vue.http.post('/cldEdi/api/sysinfo').then(function ({body: data}) {
				var {data: info} = data
				if (!info.enable) {
					info.showDomain = true
				}
				return Promise.resolve(info)
			})
		}
	}
	// }}}
}



// WEBPACK FOOTER //
// ./src/configs/SysConfig.js